<template>
  <div class="upload-img-list c:row-start-center c:flex-wrap">
    <div
      v-for="(item, index) in list"
      :key="index"
      class="list-item c:row-center"
    >
      <img :src="item.url" class="img" alt="" @click="preview(index)" />
      <img
        v-if="!disabled"
        src="@/assets/icons/remove-image.svg"
        class="remove"
        alt=""
        @click="throttledOnRemoveClick(index)"
      />
    </div>
    <div
      class="list-item upload c:row-center"
      :class="{ disabled: disabled || list.length >= maxCount }"
      @click="throttledOnUploadClick"
    >
      <img src="@/assets/icons/camera.svg" alt="" />
    </div>
    <CConfirm ref="refCConfirm" />
  </div>
</template>

<script>
import { ImagePreview } from "vant";
import { fileRead, upload } from "@/api";
import { chooseImage, throttle } from "@/utils";
import CConfirm from "./CConfirm.vue";

const M = Math.pow(2, 20);

export default {
  components: { CConfirm },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    maxCount: {
      type: Number,
      default: 99,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      images: [],
    };
  },
  watch: {
    value: {
      handler(value) {
        // console.log("list", value);
        this.images = value.map((image) => {
          this.formatImage(image);
          return image;
        });
      },
      immediate: true,
    },
  },
  computed: {
    list() {
      return this.images.filter((image) => {
        return image.url && !image.deleted;
      });
    },
  },
  created() {
    this.throttledOnPreviewClick = throttle(this.preview, 500);
    this.throttledOnRemoveClick = throttle(this.remove, 500);
    this.throttledOnUploadClick = throttle(this.choose, 500);
  },
  methods: {
    async formatImage(image) {
      const { filename, url } = image;
      if (url) return;
      if (filename) {
        try {
          const blob = await fileRead(filename);
          image.url = URL.createObjectURL(blob);
          this.$emit("input", [...this.images]);
        } catch (error) {
          console.log("formatImage error", error);
          image.url = "";
        }
      }
    },
    async choose() {
      if (this.disabled || this.images.length >= this.maxCount) return;
      console.log("will choose files");
      const files = await chooseImage();
      console.log("choosed", files);
      const file = files[0];
      if (file) {
        if (file.size >= M * 5) {
          console.log("file too large");
          throw new Error("请上传小于 5M 的图片");
        }
        this.upload(file);
      } else {
        console.log("no files");
      }
    },
    async upload(file) {
      const image = {
        url: URL.createObjectURL(file),
      };

      const formData = new FormData();
      formData.append("file", file);

      try {
        this.$toast.loading({
          message: "上传中",
          forbidClick: true,
        });
        const filename = await upload(formData);
        image.filename = filename;
        this.images.push(image);
        this.$emit("input", [...this.images]);
        this.$emit("upload");
      } catch (error) {
        console.log("upload error", error);
        if (error?.message) this.$toast(error.message);
        else this.$toast.clear();
      }
    },
    preview(index) {
      ImagePreview(
        this.list.map((image) => image.url),
        index
      );
    },
    remove(index) {
      this.$refs.refCConfirm
        .show("确定删除吗")
        .then(() => {
          this.images[index] = {
            ...this.images[index],
            deleted: true,
          };
          this.$emit("input", [...this.images]);
          this.$emit("remove", index);
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.upload-img-list {
  width: 100%;
  gap: 15px;

  .list-item {
    width: 72.5px;
    height: 72.5px;
    position: relative;
    background-color: #f7f7f7;
    &.upload {
      cursor: pointer;
      justify-content: center;
      align-items: center;

      &.disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }
      & > img {
        width: 24px;
        height: 24px;
      }
    }
    .remove {
      width: 24px;
      height: 24px;
      padding: 4px;
      position: absolute;
      right: 0;
      top: 0;
      z-index: 1;
    }
    .img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
